<template>
  <div v-cloak>
    <el-carousel
      v-if="operateData && operateData.homePageAd_01 && operateData.homePageAd_01.switch"
      trigger="click"
      height="80px"
    >
      <el-carousel-item v-for="(item, index) in operateData.homePageAd_01.list" :key="index">
        <a
          :href="item.link || 'javascript:;'"
          :style="{
            background: `url(${item.src}) no-repeat ${item.backgroundColor}`,
          }"
          :target="item.isNewTabOpen ? '_blank' : ''"
          class="survey"
        ></a>
      </el-carousel-item>
    </el-carousel>

    <el-row :gutter="20">
      <el-col :span="16"
        ><div class="grid-content bg-purple">
          <data-view></data-view>
          <index-chart></index-chart>
        </div>
      </el-col>
      <el-col :span="8"
        ><div class="grid-content bg-purple">
          <Ranking></Ranking>
          <wait-pay></wait-pay>
          <wait-back></wait-back></div
      ></el-col>
    </el-row>

    <!-- 数据概览 -->

    <div v-show="showDownload" class="fixed-div" @click="closeDownload">
      <!-- <span class="text">当前仅支持安卓系统手机</span> -->
    </div>
    <template v-if="showDownload">
      <div class="pic-new" v-if="$store.getters.isNew">
        <i @click="closeDownload" class="chahao iconfont-erp iconguanbi"></i>

        <img src="~@/assets/images/index-download-new.jpg" alt="" srcset="" />
      </div>
      <i class="pic" v-else>
        <img src="~@/assets/images/index-download.jpg" alt="" srcset="" />
      </i>
    </template>

    <!-- <div v-show="showNotice" class="fixed-div">
    </div>
    <template v-if="showNotice">
      <div class="pic-new">
        <i @click="closeNotice" class="chahao iconfont-erp iconguanbi"></i>

        <img src="~@/assets/images/notice-2024-02-20.jpg" alt="" srcset="" />
      </div>
    </template> -->
  </div>
</template>

<script>
import dataView from "./components/dataView";
import waitPay from "./components/waitPay";
import waitBack from "./components/waitBack";
import indexChart from "./components/indexChart";
import Ranking from "./components/Ranking";
import { mapState } from "vuex";

export default {
  name: "app",
  components: {
    dataView,
    waitPay,
    waitBack,
    indexChart,
    Ranking,
  },
  data() {
    return {
      showDownload: true,
      showNotice: true,
    };
  },

  created() {
    let showDownload = localStorage.getItem("showDownload", false);
    let notice = localStorage.getItem("notice", false);

    this.showNotice = notice !== "2024-02-20";

    if (this.showNotice) {
      this.showDownload = false;
    } else if (showDownload != undefined) {
      this.showDownload = showDownload === "false" ? false : true;
    }
  },
  methods: {
    closeDownload() {
      this.showDownload = false;
      localStorage.setItem("showDownload", false);
    },
    closeNotice() {
      this.showNotice = false;
      localStorage.setItem("notice", "2024-02-20");
    },
  },
  computed: {
    ...mapState({
      operateData: (state) => state.operate.data,
    }),
  },
};
</script>

<style lang="scss" scoped>
.wait-deal {
  background: #fff;
  height: 193px;
  padding: 20px;
  overflow: hidden;
  margin-bottom: 20px;

  > li {
    width: 50%;
    float: left;
  }
}
.chahao {
  position: absolute;
  z-index: 1;
  right: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: #999;
  cursor: pointer;
}
.pic-new {
  position: fixed;
  z-index: 100;
  width: 40%;
  height: 50%;
  left: 50%;
  top: 15%;
  margin-left: -20%;
  img {
    display: block;
    width: 100%;
  }
}
.pic {
  position: absolute;
  width: 40%;
  height: 50%;
  left: 50%;
  top: 15%;
  margin-left: -20%;
  img {
    display: block;
    width: 100%;
  }
}
.fixed-div {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: 162px;
    margin-left: 5px;
  }
}
.survey {
  // background: url(./../../assets/images/survey.jpg) no-repeat #2a2371;
  height: 80px;
  cursor: pointer;
  display: block;
  margin-bottom: 10px;
}
</style>
